import { CharlieQrCode } from '@ver.id/libs.ui.charlie';
import { type InstallLinks } from '../../data/installLinks';
import { installPageUrl } from '../../utils/appLinks';

/**
 * EmbeddedInstallInstructions — The install code: smaller than the scan code, no logo, with
 * the store links inside the box, so the two are never confused. It opens
 * Ronan's install page, which forwards a phone to the right store.
 */
export default function EmbeddedInstallInstructions({
  appName,
  links,
  label,
}: {
  appName: string;
  links: InstallLinks;
  label: string;
}) {
  return (
    <div className="flex h-[184px] w-full shrink-0 flex-col items-center justify-center gap-2 rounded-[10px] border border-border bg-white leading-none text-[#0a0a0a]">
      <div role="img" aria-label={label}>
        <CharlieQrCode data={installPageUrl(appName)} size={132} />
      </div>
      <span className="text-[13px] leading-[18px] text-[#5b5b5b]">
        {links.apple && (
          <a
            href={links.apple}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0a0a0a] underline"
          >
            App Store
          </a>
        )}
        {links.apple && links.android && ' · '}
        {links.android && (
          <a
            href={links.android}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0a0a0a] underline"
          >
            Google Play
          </a>
        )}
      </span>
    </div>
  );
}
